var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(-34 -25)",
    fill: "#07043B",
    fillRule: "evenodd",
    fontFamily: "Helvetica",
    fontSize: 45
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33,
    y: 56
  }, "\u201C"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotes);
export default __webpack_public_path__ + "static/media/icon-quotes.fefaf075deb7ea02d1f34e3bb4c10291.svg";
export { ForwardRef as ReactComponent };